"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPTY_ARRAY = void 0;
// For not to create new ref any time we want to return an empty array
// TODO: Check all code base which selectors return [] and replace  it with the EMPTY_ARRAY
exports.EMPTY_ARRAY = [];
//# sourceMappingURL=index.js.map